import React from 'react'
import { SiGmail } from 'react-icons/si'
import { HiPhone } from "react-icons/hi";
import { FaPaperPlane } from 'react-icons/fa';
import Connectionstab from './Connectionstab';

const ContactInfoCard = ({ icon: Icon, title, content }) => (
  <div className="flex items-center p-6 bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 hover:bg-white/10 transition-all duration-300 transform hover:scale-105">
    <div className="p-4 bg-purple-600/20 rounded-full mr-5">
      <Icon className="w-6 h-6 text-purple-400" />
    </div>
    <div>
      <h4 className="text-gray-400 text-sm font-medium mb-1">{title}</h4>
      <p className="text-white text-lg font-semibold">{content}</p>
    </div>
  </div>
);

const ContactForm = () => {
  return (
    <div className="pt-24 pb-12 px-4 min-h-screen text-white flex items-center justify-center">
      <div className="max-w-6xl w-full mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
            Get In Touch
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          <p className="mt-4 text-xl text-gray-400">Let's discuss how we can work together</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info Side */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold mb-8">Contact Information</h3>

            <div className="space-y-6">
              <ContactInfoCard
                icon={SiGmail}
                title="Email Address"
                content="sarvadnyaawaghad10@gmail.com"
              />
              <ContactInfoCard
                icon={HiPhone}
                title="Phone Number"
                content="+91 7588711657"
              />
            </div>

            <div className="mt-12">
              <h3 className="text-xl font-semibold mb-6">Connect with me</h3>
              <div className="p-6 bg-white/5 backdrop-blur-md rounded-2xl border border-white/10">
                <Connectionstab />
              </div>
            </div>
          </div>

          {/* Contact Form Side */}
          <div className="bg-white/5 backdrop-blur-md p-8 rounded-3xl border border-white/10">
            <form action="https://formspree.io/f/mrgvwazj" method="POST" className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label htmlFor="username" className="text-sm font-medium text-gray-300">Your Name</label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    placeholder="John Doe"
                    required
                    autoComplete="off"
                    className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl focus:outline-none focus:border-purple-500 focus:bg-white/10 text-white transition-all placeholder-gray-500"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className="text-sm font-medium text-gray-300">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="john@example.com"
                    required
                    autoComplete="off"
                    className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl focus:outline-none focus:border-purple-500 focus:bg-white/10 text-white transition-all placeholder-gray-500"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label htmlFor="subject" className="text-sm font-medium text-gray-300">Subject</label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  placeholder="Project Inquiry"
                  required
                  autoComplete="off"
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl focus:outline-none focus:border-purple-500 focus:bg-white/10 text-white transition-all placeholder-gray-500"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="textarea" className="text-sm font-medium text-gray-300">Message</label>
                <textarea
                  name="textarea"
                  id="textarea"
                  cols="30"
                  rows="5"
                  placeholder="Tell me about your project..."
                  required
                  autoComplete="off"
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl focus:outline-none focus:border-purple-500 focus:bg-white/10 text-white transition-all placeholder-gray-500 resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full py-4 px-8 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-xl text-white font-bold text-lg shadow-lg hover:shadow-purple-500/30 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3"
              >
                <FaPaperPlane className="text-sm" />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactForm
